export default "__VITE_ASSET__c5132320__"